import { render, staticRenderFns } from "./NormalChallengeBox.vue?vue&type=template&id=75b37b54&scoped=true"
import script from "./NormalChallengeBox.vue?vue&type=script&lang=js"
export * from "./NormalChallengeBox.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "75b37b54",
  null
  
)

export default component.exports